import { RouterPaths } from "../routerPaths";
import { importPages } from "../lazyRoute";

const nonWorkingRoutes = [
    {
        path: RouterPaths.NONWORKINGDAYS,
        element: importPages.NonWorkingDays,
    },
    {
        path: RouterPaths.ACADEMICWEEKSETUP,
        element: importPages.AcademicWeekSetup,
    },
];
export default nonWorkingRoutes;
